import { render, staticRenderFns } from "./SignaturesApprovalList.vue?vue&type=template&id=0d586b3c&scoped=true&"
import script from "./SignaturesApprovalList.vue?vue&type=script&lang=js&"
export * from "./SignaturesApprovalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d586b3c",
  null
  
)

export default component.exports